import React from 'react';
import { BackHomeBtn } from './showBtn'


/**
 * 
 * not Found
 * 
 */
const NotFound = () => {

  return (
    <div className="fixed left-1/2 top-1/2 min-w-680px transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center select-none">
      <>
        <p className="text-[#999] text-16px font-medium mt-66px mb-60px">
          (⊙o⊙)…你似乎掉入了世界黑洞里，请回到起点重新再来过
        </p>
      </> 
      <div>
        <BackHomeBtn />
      </div>
    </div>
    
  );
}

export default NotFound;